import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

const NO_REFRESH = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/me", "/auth/logout"];
let refreshing = null;

api.interceptors.response.use(undefined, async (error) => {
  const { config, response } = error;
  if (response?.status !== 401 || config._retried || NO_REFRESH.some((p) => config.url?.endsWith(p))) throw error;
  refreshing ??= api.post("/auth/refresh").finally(() => { refreshing = null; });
  try { await refreshing; } catch { throw error; }
  return api({ ...config, _retried: true });
});

export function formatApiError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d?.msg || JSON.stringify(d)).join(" ");
  return detail.msg || String(detail);
}

export const photoUrl = (p) => (p.startsWith("http") ? p : `${API}/files/${p}`);
export const thumbUrl = (p) => (p.startsWith("http") ? p : `${API}/files/${p}?size=thumb`);

export const gbp = (n) =>
  new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);

export const timeAgo = (iso) => {
  const s = (Date.now() - new Date(iso).getTime()) / 1000;
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

export const BRAND = {
  name: "FLS Support Centre",
  email: "Support@focusedlasersystems.com",
  whatsapp: "+44 1271 626406",
  whatsappLink: "https://wa.me/441271626406?text=" + encodeURIComponent("Hi FLS, I need help with…"),
  mainSite: "https://www.focusedlasersystems.com",
};
